import axios from "axios";
import { trainingAPI } from "../../api/TrainingAPI";
import { getTeamInformation } from "./team.actions";

export const MANAGER_SET_TEAM_LIST = "[MANAGER]_SET_TEAM_LIST";
export const MANAGER_SET_SELECTED_TEAM = "[MANAGER]_SET_SELECTED_TEAM";

export const INITIALIZE_STORE = "INITIALIZE_STORE";

export const setManagerTeamList = (data) => {
  return {
    type: MANAGER_SET_TEAM_LIST,
    data,
  };
};

export const setManagerSelectedTeam = (data) => {
  return {
    type: MANAGER_SET_SELECTED_TEAM,
    data,
  };
};


export const getManagerTeamList = () => {
  return async (dispatch) => {
    try {
      const teamList = await trainingAPI.getTeamList();
      dispatch(setManagerTeamList(teamList));
    } catch (e) {
      dispatch(setManagerTeamList([]));
      console.log(e);
    }
  };
};

export const initializeStore = () => {
  return {
    type: INITIALIZE_STORE,
  };
};

export const selectManagerTeam = (teamId, navigate) => {
  return async (dispatch, getState) => {
    const teams = getState().manager.teams;
    if (!teams || teams.length === 0) return;

    const isTeamIdValid = teams.some((team) => team.id == teamId);
    if (!isTeamIdValid) {
      localStorage.removeItem("team-id");
      delete axios.defaults.headers.common["gpsdv-team-id"];
      await dispatch(setManagerSelectedTeam(undefined));
      await dispatch(initializeStore());
      navigate("/team-selection");
      return false;
    } else {
      localStorage.setItem("team-id", teamId);
      axios.defaults.headers.common["gpsdv-team-id"] = teamId;
      await dispatch(setManagerSelectedTeam(teamId));
      await dispatch(initializeStore());
      await dispatch(getTeamInformation());
      return true;
    }
  };
};
